import {priority} from '@priority-software/priority-proto-api/lib';
import {AlertValidForCategory, RuleType} from '../../../../enums';
import {multiOptionsHaveValidValue} from '../../../../utils';
import {AlertMappedItem} from '../../../../reducer/types';
import {BusinessRuleAction} from '../../../../constants';
import {RecipientsType} from '../AutomationActionTemplate/BusinessRuleActionTemplate/enum';
import {TEmailStateType} from '../../../../../EmailEditor/reducer/types';
import {languageTabs} from '../AutomationActionToolbar/constants';

export const findDefaultValidForCategory = (ruleFormData?: priority.netitems.form.IAlertForm) => {
    if (ruleFormData) {
        if (multiOptionsHaveValidValue(ruleFormData.ValidUser as number[])) {
            return AlertValidForCategory.user;
        }
        if (ruleFormData.ValidUserInGroup) {
            return AlertValidForCategory.userInGroup;
        }
        if (multiOptionsHaveValidValue(ruleFormData.ValidGroup as number[])) {
            return AlertValidForCategory.group;
        }
    }
    return 0;
};

const isValidRecipient = (rule: AlertMappedItem) => {
    if (rule.MessageType === BusinessRuleAction.Webhook) return Boolean(rule.WebHook);

    switch (rule.MailType) {
        case RecipientsType.email:
            return rule.RecipientMail?.length > 0;
        case RecipientsType.phone:
            return rule.RecipientMail?.[0]?.length > 0;
        case RecipientsType.user:
            return rule.RecipientUser?.length > 0;
        case RecipientsType.group:
            return rule.RecipientGroup?.length > 0;
        case RecipientsType.field:
            return typeof rule.RecipientField === 'number';
        default:
            return false;
    }
};

const hasValidMessage = (rule: AlertMappedItem) => {
    return (rule.Messages || []).some(item => item.Message?.trim());
};

const hasValidCoverLetter = (rule: AlertMappedItem) => {
    return (rule.CoverLetters || []).some(item => item.Message?.trim());
};

const hasValidEmailTemplate = (newEmailTemplate: TEmailStateType) => {
    for (const tab of languageTabs) {
        const emailHtml = newEmailTemplate?.[tab.id]?.emailHtml;

        if (emailHtml?.length > 0) {
            return true;
        }
    }

    return false;
};

export const isSaveEnabled = (
    rule: AlertMappedItem,
    type: RuleType,
    newEmailTemplate?: TEmailStateType
) => {
    if (type === RuleType.autofill) {
        return Boolean(rule.RecipientField) && Boolean(rule.Form.UpdateField);
    } else if (type === RuleType.business || type === RuleType.bpm) {
        if (
            rule.MessageType === BusinessRuleAction.ErrorMsg ||
            rule.MessageType === BusinessRuleAction.WarningMsg
        ) {
            return hasValidMessage(rule);
        } else if (
            rule.MessageType === BusinessRuleAction.OpenTask ||
            rule.MessageType === BusinessRuleAction.TextMsg ||
            rule.MessageType === BusinessRuleAction.PushNotification ||
            rule.MessageType === BusinessRuleAction.Webhook
        ) {
            return hasValidMessage(rule) && isValidRecipient(rule);
        } else if (rule.MessageType === BusinessRuleAction.EmailMsg) {
            if (newEmailTemplate) {
                return hasValidEmailTemplate(newEmailTemplate) && isValidRecipient(rule);
            } else if (rule.CoverLetters && rule.CoverLetters.length > 0) {
                /** when re-entering a saved rule, the newEmailTemplate is not initiated yet, that why I used here rule.coverLetter as it being returned from the server  */
                return hasValidCoverLetter(rule) && isValidRecipient(rule);
            }

            return hasValidMessage(rule) && isValidRecipient(rule);
        } else if (rule.MessageType === BusinessRuleAction.UserVerification) {
            return true;
        }

        // Additional checks for the BPM actions
        if (rule.MessageType === BusinessRuleAction.AssignTo) {
            return isValidRecipient(rule);
        } else if (rule.MessageType === BusinessRuleAction.AllowStatusChange) {
            return isValidRecipient(rule);
        } else if (rule.MessageType === BusinessRuleAction.ChangeStatusTo) {
            return Boolean(rule.BPM?.ToStatus);
        }

        return false;
    }
    return true;
};
